type Tokens = {
  accessToken: string;
  refreshToken: string;
};

type Token = "accessToken" | "refreshToken";

export enum LocalStorageKey {
  user_id = "userId",
  always_clear_messages = "always_clear_messages",
  actions_count = "actions_count",
  notifications_hash = "notifications_hash",
  last_verification_email_sent = "last_verification_email_sent",
  referral_tag = "referral_tag",
  sidebar_state = "sidebar_state",
  feedback_sent = "feedback_sent",
}

export default class LocalStorageService {
  static setTokens({ accessToken, refreshToken }: Tokens) {
    if (typeof window === "undefined") return;
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  }

  static getToken(tokenType: Token) {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(tokenType);
  }

  static removeTokens() {
    if (typeof window === "undefined") return;
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }

  static setItem(key: LocalStorageKey, value: string) {
    if (typeof window === "undefined") return;
    localStorage.setItem(key, value);
  }

  static getItem(key: LocalStorageKey) {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(key);
  }

  static removeItem(key: LocalStorageKey) {
    if (typeof window === "undefined") return;
    localStorage.removeItem(key);
  }
}
